import { Navigate, useRoutes } from 'react-router-dom';
import PropTypes from 'prop-types';
// layouts
import MainLayout from 'src/layouts/main';
// config
// import { PATH_AFTER_LOGIN } from 'src/config-global';
//
import { AuthGuard } from 'src/auth/guard';
import useBrandName from 'src/hooks/use-brand-name';

import { mainRoutes, HomePage, EuropePage } from './main';
import { authRoutes } from './auth';
import { authDemoRoutes } from './auth-demo';
import { dashboardRoutes } from './dashboard';
import { componentsRoutes } from './components';

// Conditional wrapper component for agent protection
const ConditionalAuthGuard = ({ children }) => {
  const { isAgent } = useBrandName();

  if (isAgent) {
    return <AuthGuard>{children}</AuthGuard>;
  }

  return <>{children}</>;
};

ConditionalAuthGuard.propTypes = {
  children: PropTypes.node,
};

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // SET INDEX PAGE WITH SKIP HOME PAGE
    // {
    //   path: '/',
    //   element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    // },

    // ----------------------------------------------------------------------

    // SET INDEX PAGE WITH HOME PAGE
    {
      path: '/',
      element: (
        <ConditionalAuthGuard>
          <MainLayout>
            <HomePage />
          </MainLayout>
        </ConditionalAuthGuard>
      ),
    },
    // {
    //   path: '/europe',
    //   element: (
    //     <MainLayout>
    //       <EuropePage />
    //     </MainLayout>
    //   ),
    // },

    // Auth routes
    ...authRoutes,
    // ...authDemoRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // Main routes
    ...mainRoutes,

    // Components routes
    // ...componentsRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
